import { Fragment, ReactElement } from "react";
import TableContainer from "../../../../components/tableContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";
import StyledTableRow from "../../../../components/styledTableRow";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CheckIcon from "@mui/icons-material/Check";
import { Alloy_Tolerance } from "../types";


interface IProps {
  height: number;
  groups: string[];
  records: any[];
}

interface IElement {
  weight?: number;
  suggestedValue?: number;
}

interface IIndicatorProps {
  odd: boolean;
  element?: IElement;
}

const valueWidth = 70;
const subHeaderTop = 33;


const columnABase = {
  backgroundColor: "#6d7d85",
  top: subHeaderTop,
  padding: "4px"
};

const columnBBase = {
  backgroundColor: "#b0bec5",
  top: subHeaderTop,
  padding: "4px"
};

const columnA = {
  ...columnABase,
  width: valueWidth,
  minWidth: valueWidth,
  maxWidth: valueWidth,
};

const columnB = {
  ...columnBBase,
  width: valueWidth,
  minWidth: valueWidth,
  maxWidth: valueWidth,
};

const Indicator = ({ element, odd }: IIndicatorProps): ReactElement => {
  const weight = element?.weight ?? 0;
  const suggestedValue = element?.suggestedValue ?? 0;
  const diff = weight - suggestedValue;
  const style = {
    backgroundColor: odd ? "rgba(0, 0, 0, .1)" : undefined,
    padding: "4px",
    width: valueWidth,
    minWidth: valueWidth,
    maxWidth: valueWidth,
  };
  const diffStyle = {
    ...style,
  };

  let icon = <CheckIcon />;
  if (suggestedValue * Alloy_Tolerance < Math.abs(diff)) {
    diffStyle.backgroundColor = "red";
    icon = diff > 0 ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />;
  }

  return (
    <>
      <TableCell align="right" style={style} >
        {suggestedValue.toFixed(0)}
      </TableCell>
      <TableCell align="right" style={style} >
        {weight.toFixed(0)}
      </TableCell>
      <TableCell align="right" style={diffStyle}>
        {Math.abs(diff).toFixed(0)}
      </TableCell>
      <TableCell align="right" style={{ ...diffStyle,   width: 29,
        minWidth: 29, }} >
        {icon}
      </TableCell>
    </>
  );
};

const AdditionsTable = ({ height, groups, records }: IProps): ReactElement => {
  const tableContainerHeight = height - 88;

  return (
    <TableContainer  className="flex-grow-1" style={{ maxHeight: tableContainerHeight, height: tableContainerHeight, overflowX: "auto" }}>
      <Table stickyHeader={true} size={"small"}>
        <TableHead>
          <TableRow>
            <TableCell style={{ backgroundColor: "#b0bec5", minWidth: 200, maxWidth: 200 }}  />
            { groups.map((c, i) => {
              return (
                <TableCell sx={{ backgroundColor: i % 2 === 0 ? "#6d7d85" : "#6d7d85" }}
                  colSpan={4} align="center" key={`hc-${i}`}>{c}</TableCell>
              );
            })}
          </TableRow>
          <TableRow>
            <TableCell style={{ backgroundColor: "#b0bec5", top: subHeaderTop, padding: 2, minWidth: 200, maxWidth: 200 }}>Alloys</TableCell>
            { groups.map((_c, i) => {
              const flag = i % 2 === 0;

              return (
                <Fragment key={`sc-${i}`}>
                  <TableCell style={flag ? columnA : columnB} align="center">SPEC</TableCell>
                  <TableCell style={flag ? columnA : columnB} align="center">REAL</TableCell>
                  <TableCell style={flag ? columnA : columnB} align="center">DIFF</TableCell>
                  <TableCell style={flag ? columnABase : columnBBase} className="p-1"/>
                </Fragment>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          { records.map((row, ri) => {

            return (
              <StyledTableRow key={`row-${ri}`}>
                <TableCell style={{ padding: 4, width: 200, maxWidth: 200 }}>{row.material}</TableCell>
                { groups.map((c, ci) => {
                  const element = row.groups[c]
                    ? { weight: row.groups[c].weight.sum(), suggestedValue: row.groups[c].suggestedValue.sum() }
                    : undefined;

                  return (
                    <Indicator key={`row-${ri}-${ci}`} element={element} odd={ci % 2 === 0} />
                  );
                })}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AdditionsTable;
